import React, { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { object } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { navigate } from '@reach/router'
import BreadcrumbGlobal from '../../../../components/BreadcrumbGlobal/BreadcrumbGlobal'
import FluxosPagamento from '../../../../components/FluxosPagamento/FluxosPagamento'
import { useGlobal } from '../../../../contexts/GlobalContext'
import { FluxosPagamentoProvider } from '../../../../contexts/FluxosPagamentoContext'
import { useModalidade } from '../../../../contexts/ModalidadeContext'
import { useUpgradePlano } from '../../../../contexts/UpgradePlanoContext'
import { LABEL_BOTAO_ULTIMA_ETAPA, TITULO_PAGINA } from './constantsUpgradePlano'
import { TIPO_PROMOCAO_UPGRADE_PLANO } from '../../../../components/CupomPromocao/constantsPromocao'
import {
  FLUXOS_PAGAMENTO,
  PLANO_ANUAL,
  EVENTOS_GA,
  STATUS_CANCELADO,
  ROUTE_BASEPATH,
  PLANO_MENSAL,
  INFORMACAO_MODALIDADES,
  PLANO_TRIMESTRAL,
} from '../../../../constants'
import { isEmptyObject } from '../../../../utils/helpers/helpers'
import { tiposDePlanos } from '../../../../containers/Modalidade/Plano/constantsPlano'
import { TIPOS_FLUXO_BRINDES } from '../../../../components/FluxosPagamento/constantsFluxosPagamento'
import { getAssinaturaDoAssociadoPorModalidade, getInformacoesModalidadePorAssinatura } from '../../../../utils/helpers/helpersAssinatura'
import { enviaEventoGA } from '../../../../utils/helpers/helpersGA'
import { URLS_APP } from '../../../../config'
import { getValorPlano, getTextoDescontoUpgradePlano } from '../../../../utils/helpers/helperPlano'
import { normalizeString } from '../../../../utils/formatter/formatter'
import { criarUsuarioLog, TIPOS_LOG_USUARIO } from '../../../../api/usuarioLog.servico'

const Titulo = styled.h1`
  margin: 25px 0 10px 0;
`

const SubTitulo = styled.h3`
  ${StyleGuide.tipografia.textoDefault};
  margin: 0;

  span {
    ${StyleGuide.boldFonte};
  }
`

function Upgrade( { location } ) {
  const visualizacaoInicialBreadcrumb = [ 'Entrega', 'Pagamento', 'Conclusão' ]
  const {
    dadosGlobaisAssociado,
    modalidadeURL,
    setFluxoGA,
    verifyAtMaintenance,
  } = useGlobal()
  const { fetchPlanos, listaPlanosPorModalidade } = useModalidade()
  const { dadosRetornoRequisicao, loadingUpgrade, postUpgradePlano, sucessoUpgrade, setLoadingUpgrade } = useUpgradePlano()
  const [ assinaturaModalidadeURL, setAssinaturaModalidadeURL ] = useState()
  const [ dadosPlanoAnual, setDadosPlanoAnual ] = useState()
  const [ dadosDescontoCombo, setDadosDescontoCombo ] = useState( {} )
  const [ visualizacaoBreadcrumb, setVisualizacaoBreadcrumb ] = useState( visualizacaoInicialBreadcrumb )
  const [ brindesFluxo, setBrindesFluxo ] = useState( [] )
  useEffect( () => {
    if ( modalidadeURL ) {
      fetchPlanos( modalidadeURL )
    }
  }, [ modalidadeURL ] )

  useEffect( () => {
    setFluxoGA( EVENTOS_GA.UPGRADE.FLUXO )
    criarUsuarioLog( TIPOS_LOG_USUARIO.INICIOU_CHECKOUT_ADA_UPGRADE )
  }, [] )

  useEffect( () => {
    if ( dadosGlobaisAssociado && dadosGlobaisAssociado.assinaturas.length ) {
      const modalidadeIncluidaPathname = location.pathname.split( '/' ).find( path => {
        const infoModalidadeIncluidaNoPathname = INFORMACAO_MODALIDADES.find( modalidade => modalidade.slug === path )
        return !isEmptyObject( infoModalidadeIncluidaNoPathname )
      } )
      let assinaturaPorModalidade
      if ( modalidadeIncluidaPathname ) {
        assinaturaPorModalidade = getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidadeIncluidaPathname )
      }
      let assinaturaPermitidaUpgrade = {}
      if ( assinaturaPorModalidade && ( ( assinaturaPorModalidade.plano === PLANO_MENSAL.visualizacao || assinaturaPorModalidade.plano === PLANO_TRIMESTRAL.visualizacao ) && assinaturaPorModalidade.status !== STATUS_CANCELADO ) ) {
        assinaturaPermitidaUpgrade = assinaturaPorModalidade
      }
      setAssinaturaModalidadeURL( assinaturaPermitidaUpgrade )
    }
  }, [ dadosGlobaisAssociado, location ] )

  useEffect( () => {
    if ( !isEmptyObject( listaPlanosPorModalidade ) && modalidadeURL ) {
      const planosNaoPresente = listaPlanosPorModalidade[ tiposDePlanos.NAO_PRESENTE ]
      const planoAnual = planosNaoPresente.find( plano => plano.tipo === PLANO_ANUAL.visualizacao )
      if ( !isEmptyObject( planoAnual ) ) {
        const { id, tipo, valorTotal } = planoAnual
        setDadosPlanoAnual( {
          id,
          tipo,
          'valor': getValorPlano(
            assinaturaModalidadeURL,
            valorTotal,
            normalizeString( modalidadeURL ),
            'anual'
          )
        } )
      }
    }
  }, [ listaPlanosPorModalidade, modalidadeURL ] )

  const fazerUpgradePlano = async dadosFluxo => {
    enviaEventoGA( EVENTOS_GA.UPGRADE.FLUXO, EVENTOS_GA.UPGRADE.ACOES.CONCLUSAO )
    setLoadingUpgrade( true )
    const atMaintenance = await verifyAtMaintenance()

    if ( !isEmptyObject( dadosFluxo ) && !atMaintenance ) {
      postUpgradePlano( assinaturaModalidadeURL, dadosFluxo )
    } else {
      setLoadingUpgrade( false )
    }
  }

  const montarFluxoComBrindes = brindes => {
    if ( brindes.length > 1 ) {
      setBrindesFluxo( brindes )
      setVisualizacaoBreadcrumb( [ 'Entrega', 'Pagamento', 'Brinde', 'Conclusão' ] )
    }
  }

  if ( assinaturaModalidadeURL ) {
    if ( isEmptyObject( assinaturaModalidadeURL ) ) {
      navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${modalidadeURL}` )
      return null
    } else {
      return (
        <Fragment>
          <BreadcrumbGlobal
            exactPath="upgrade"
            nomeAlternativo="Upgrade"
            palavrasExcluidas={ /entrega|pagamento|brindes|conclusao/u }
          />

          <Titulo>{TITULO_PAGINA}</Titulo>

          <SubTitulo
            dangerouslySetInnerHTML={{
              '__html': getTextoDescontoUpgradePlano(
                modalidadeURL,
                assinaturaModalidadeURL.plano,
                PLANO_ANUAL.slug
              )
            }}
          />

          <FluxosPagamentoProvider
            descontoCombo={ setDadosDescontoCombo }
            fluxoPagamentoAtual={ TIPOS_FLUXO_BRINDES[ FLUXOS_PAGAMENTO.UPGRADE ] }
            idAssinaturaAtual={ assinaturaModalidadeURL.id }
            modalidadeParaBrinde={
              getInformacoesModalidadePorAssinatura( modalidadeURL ).id
            }
            montarFluxoComBrindes={ montarFluxoComBrindes }
          >
            <FluxosPagamento visualizacaoEtapas={ visualizacaoBreadcrumb }>
              <FluxosPagamento.Entrega planoExterno={ dadosPlanoAnual } />

              <FluxosPagamento.Pagamento
                pixPlanoAnual
              />

              {brindesFluxo.length ? (
                <FluxosPagamento.Brindes brindesFluxo={ brindesFluxo } />
              ) : (
                []
              )}

              <FluxosPagamento.Conclusao
                concluirFluxo={ dados => fazerUpgradePlano( dados ) }
                dadosDescontoCombo={ dadosDescontoCombo }
                dadosRetornoRequisicao={ dadosRetornoRequisicao }
                fluxo={ FLUXOS_PAGAMENTO.UPGRADE }
                fluxoTemPromocao
                idAssinatura={ assinaturaModalidadeURL.id }
                labelBotaoUltimaEtapa={ LABEL_BOTAO_ULTIMA_ETAPA }
                loadingRequisicao={ loadingUpgrade }
                respostaRequisicao={ sucessoUpgrade }
                tipoAssinaturaPromocao={ TIPO_PROMOCAO_UPGRADE_PLANO }
              />
            </FluxosPagamento>
          </FluxosPagamentoProvider>
        </Fragment>
      )
    }
  }

  return null
}

Upgrade.propTypes = {
  'location': object.isRequired
}

export default Upgrade

